// extracted by mini-css-extract-plugin
export default {"Divider":"BalancePage_Divider__JYaBM","PartialBalanceTextField":"BalancePage_PartialBalanceTextField__Baldr","PartialBalanceHelperText":"BalancePage_PartialBalanceHelperText__zwF07"};